import { acaNamesACADEMONDO } from '../src/aca-names-ACADEMONDO';

export const acaNames = acaNamesACADEMONDO;
